import React from 'react'
import PropTypes from 'prop-types'

const SideListLabel = ({ label, recordsCounter, totalForDifferentTab, selectionCounter }) => {
	return (
		<div>
			<span style={{ marginRight: '10px' }}>{label}</span>
			<span style={{ color: '#C3C3C3' }}>
				{recordsCounter && totalForDifferentTab &&
                `${selectionCounter ? `${selectionCounter} / ${totalForDifferentTab}` : totalForDifferentTab || 0}`
				}
			</span>
		</div>
	)
}

SideListLabel.propTypes = {
	label: PropTypes.string,
	totalForDifferentTab: PropTypes.number,
	recordsCounter: PropTypes.bool,
	selectionCounter: PropTypes.any
}

export default SideListLabel
